import classNames from 'classnames';
import React, { FC } from 'react';
import { $Formutil } from 'react-antd-formutil';
import { connect } from 'react-formutil';
import FormLayout from 'components/FormLayout';
import Phone from 'components/forms/Phone';
import Telcode from 'components/forms/Telcode';
import classList from 'utils/classlist';
import './style.scss';

export interface TelPhoneFieldType {
    tel_code: string;
    phone: string;
}

export interface TelPhoneProps {
    $formutil: $Formutil<TelPhoneFieldType>;
    phoneName?: string;
    telcodeName?: string;
    label?: string;
    colon?: boolean;
    size?: 'large' | 'middle' | 'small';
    disabled?: boolean;
    defaultTelcode?: number;
    line?: boolean;
    disabledValidate?: boolean; // 禁用校验
    className?: string;
}

const TelPhone: FC<TelPhoneProps> = ({
    label,
    colon = true,
    size = 'middle',
    telcodeName = 'tel_code',
    phoneName = 'phone',
    disabled,
    defaultTelcode,
    line = true,
    disabledValidate,
    className
}) => {
    return (
        <div className={classNames('telphone-root', { 'telphone-root-line': line }, className)}>
            {!!label && (
                <div className="ant-form-item-label">
                    <label className={classList({ 'ant-form-item-no-colon': !colon })}>{label}</label>
                </div>
            )}
            <FormLayout layout="1:2">
                <Telcode
                    size={size}
                    name={telcodeName!}
                    type="telCountry"
                    disabled={disabled}
                    defaultTelcode={defaultTelcode}
                />
                <Phone
                    disabledValidate={disabledValidate}
                    size={size}
                    name={phoneName}
                    disabled={disabled}
                    line={line}
                />
            </FormLayout>
        </div>
    );
};

export default connect(TelPhone);
